import React from 'react';

import { MainWrapper, InnerWrapper, Heading } from 'commonStyles';
import * as S from '../../Style';
import { bookingSteps, cardViewMobileProps } from '../../config';
import TrainForm from '../TrainForm/TrainForm';
import PassengerDetails from '../PassengerDetails/PassengerDetails';
import ConfirmationBox from '../ConfirmationBox/ConfirmationBox';
import { ConditionalWrapper } from 'UtilityComponents/Util';

function TrainBookingPage({ isMobile }) {
	const leftSection = () => (
		<S.LandingPageSection $width={isMobile ? '95%' : '27%'} margin={isMobile ? 'auto' : '0px'}>
			{!isMobile && (
				<>
					<S.TrainIcon icon='icTrain' />
					<Heading fontSize='56px' marBt='42px'>Book Train Tickets</Heading>
				</>
			)}
			<ul>
				{bookingSteps.map((item, index) => (
					<S.ListLi key={index}>
						<S.BulletWrap
							color='#fff'
							align='center'
							$width='30px'
							right_M='12'
							bdrRad='50%'
							height='30px'>
							{item.id}
						</S.BulletWrap>
						<S.ListItem>{item.value}</S.ListItem>
					</S.ListLi>
				))}
			</ul>
		</S.LandingPageSection>
	);

	return (
		<>
			<MainWrapper>
				<S.ImageBannerWrap>
					<InnerWrapper spaceBetween makeFlex>
						{leftSection()}
						<S.LandingPageSection $width={isMobile ? '100%' : '70%'}>
							<ConditionalWrapper
								condition={isMobile}
								wrapper={(children) => (
									<S.CardView {...cardViewMobileProps}>
										{children}
									</S.CardView>
								)}>
								<TrainForm />
							</ConditionalWrapper>
							<PassengerDetails />
							<ConfirmationBox />
						</S.LandingPageSection>
					</InnerWrapper>
				</S.ImageBannerWrap>
			</MainWrapper>
		</>
	);
}

export default TrainBookingPage;
